import * as Actions from '../../actions/register/index';

const initialState = null;

const brand = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_BRAND:
        {
            return action.payload;
        }

        case Actions.REMOVE_BRAND:
        {
            return initialState;
        }
        
        default:
        {
            return state;
        }
    }
}

export default brand;